<script lang="ts">
	import { editable } from '$lib/storyblok/editable';
	import type { SbLink } from '$lib/storyblok/types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			title: string;
			items: Array<{ label: string; link: SbLink }>;
		}>['content'];
	}

	const { content }: Props = $props();
</script>

<nav use:editable={content} class="flex-1 text-brown-1">
	<h1 class="mb-3 text-[14px]/[160%] text-brown-1/50 lg:mb-4">{content.title}</h1>
	<ul
		class="flex flex-col gap-y-3 text-[20px] leading-[140%] tracking-[-.2px] lg:gap-y-4 lg:leading-[110%]"
	>
		{#each content.items as item}
			<li><a href={getSbUrl(item.link)} target={item.link.target}>{item.label}</a></li>
		{/each}
	</ul>
</nav>
